import React from 'react';

import PropTypes from 'prop-types';

import { ToggleContainer } from 'wanderu-component-toggle';
import { Button } from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import TravelModeCarrier from './TravelModeCarrier/TravelModeCarrier';
import Events from './events/TravelModeEvents';
import {
    TRAVEL_MODE_ICON_MAP,
    TRAVEL_MODE_TRANSLATION_MAP,
} from '../../../../constants';
import FilterEvents from '../../events';

import styles from './TravelMode.scss';

const propTypes = {
    carrierList: PropTypes.arrayOf(PropTypes.string).isRequired,
    carriers: PropTypes.object.isRequired,
    checkedState: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    i18nMoney: PropTypes.func.isRequired,
    onOnlyCarrierClick: PropTypes.func.isRequired,
    onOnlyTravelModeClick: PropTypes.func.isRequired,
    onToggleCarrier: PropTypes.func.isRequired,
    onToggleTravelMode: PropTypes.func.isRequired,
    searchParams: PropTypes.shape({
        destinationPlaceId: PropTypes.string,
        destinationText: PropTypes.string,
        originPlaceId: PropTypes.string,
        originText: PropTypes.string,
    }).isRequired,
    t: PropTypes.func.isRequired,
    totalPrice: PropTypes.number.isRequired,
    totalTrips: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
};

function TravelMode(props) {
    const {
        carrierList,
        carriers,
        checkedState = true,
        i18nMoney,
        onOnlyCarrierClick,
        onOnlyTravelModeClick,
        onToggleCarrier,
        onToggleTravelMode,
        searchParams,
        t,
        totalPrice,
        totalTrips,
        type,
    } = props;

    function handleToggleRow(isOpen) {
        const eventFunction = isOpen
            ? FilterEvents.filterCollapsed
            : FilterEvents.filterExpanded;

        eventFunction({
            filterType: 'travel_mode',
            modeType: type,
            searchParams,
        });
    }

    function handleToggleTravelMode(state) {
        onToggleTravelMode(type, state);

        Events.travelModeFilterSelected({
            previousState: checkedState,
            searchParams,
            selected: !!state,
            state,
            totalTrips,
            type,
        });
    }

    function handleOnlyTravelModeClick(e) {
        e.stopPropagation();

        onOnlyTravelModeClick(type);
    }

    return (
        <ToggleContainer
            checkboxClassName={styles.modeCheckbox}
            className={styles.modeContainer}
            disabled={!totalPrice}
            indeterminate={typeof checkedState !== 'boolean' && !!checkedState}
            isChecked={typeof checkedState === 'boolean' && checkedState}
            isOpen={type !== 'flight' && !!totalPrice}
            onChange={handleToggleTravelMode}
            onToggleRow={handleToggleRow}
            rowClassName={styles.modeRowContainer}
            title={(
                <div className={styles.subtitle}>
                    <img
                        alt=""
                        className={styles.icon}
                        src={TRAVEL_MODE_ICON_MAP[type]}
                    />

                    <span className={styles.tripMode}>
                        {t.plural(TRAVEL_MODE_TRANSLATION_MAP[type], 2)}
                    </span>

                    {!!totalPrice && (
                        <>
                            <Button
                                className={styles.onlyButton}
                                onClick={handleOnlyTravelModeClick}
                                unstyled
                            >
                                {t('only')}
                            </Button>

                            <span className={styles.price}>
                                {t('from-price', {
                                    price: totalPrice
                                        ? i18nMoney.format(Math.ceil(totalPrice), {
                                            maximumFractionDigits: 0,
                                            minimumFractionDigits: 0,
                                        })
                                        : '',
                                })}
                            </span>
                        </>
                    )}
                </div>
            )}
        >
            <TravelModeCarrier
                carrierList={carrierList}
                carriers={carriers}
                onOnlyCarrierClick={onOnlyCarrierClick}
                onToggleCarrier={onToggleCarrier}
                searchParams={searchParams}
                totalTrips={totalTrips}
                type={type}
            />
        </ToggleContainer>
    );
}

TravelMode.propTypes = propTypes;

export { TravelMode };
export default localize(TravelMode, ['t', 'i18nMoney'], 'baseApp');
